export const PUBLIC_REPORTS_SUBDOMAIN = 'reports';

/**
 * Maps the authenticated platform host (controlpanel, psp, app, etc.) to the public
 * transparency host (reports.*) for the same environment.
 */
export function getPublicReportsApiHost(platformApiHost: string): string {
  const trimmed = platformApiHost.trim();
  if (!trimmed) {
    return platformApiHost;
  }

  try {
    const url = new URL(trimmed);
    const labels = url.hostname.split('.');
    if (labels.length < 2) {
      return trimmed;
    }
    labels[0] = PUBLIC_REPORTS_SUBDOMAIN;
    url.hostname = labels.join('.');
    return url.origin;
  } catch {
    return trimmed;
  }
}

export function resolveTransparencyPublicApiHost(options: {
  platformApiHost: string;
  publicReportsApiHost?: string;
  usePublicReportsHost: boolean;
}): string {
  if (!options.usePublicReportsHost) {
    return options.platformApiHost;
  }
  return options.publicReportsApiHost ?? getPublicReportsApiHost(options.platformApiHost);
}
